import React from "react";
import OSILayer from "./OSILayer";

const OSILayerColumn = ({ title, layers, highlightedLayer, onHighlight, onClick }) => {
  return (
    <div className="osi-layer-column" style={{ padding: "10px", textAlign: "center" }}>
      <h3>{title}</h3>
      {layers.map((layer) => (
        <OSILayer
          key={layer.key}
          layerKey={layer.key}
          highlighted={highlightedLayer === layer.key}
          onHighlight={onHighlight}
          onClick={onClick}
        />
      ))}
    </div>
  );
};

export default OSILayerColumn;
